<template>
  <div class="tools">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
